import React from 'react';
import PropTypes from 'prop-types';
import RadioButtonGroup from 'material-ui/RadioButton/RadioButtonGroup';
import RadioButton from 'material-ui/RadioButton';
import utils from 'helpers/utils';
import translate from 'components/hoc/translate';

const RenderRadioButtonGroupField = (props) => {
    const {
        checkedIcon,
        disabled,
        input,
        input: { name, onChange, value },
        label,
        meta,
        options,
        otherComponent: OtherComponent,
        style,
        translate,
        uncheckedIcon,
    } = props;

    const selectedOption = utils.find(options, (option) => {
        return option.value == value;
    });

    return (
        <div style={ style }>
            <RadioButtonGroup
                disabled={ disabled }
                label={ label }
                labelPosition='right'
                name={ name }
                onChange={ onChange }
                style={ style }
                valueSelected={ selectedOption ? selectedOption.value : '' }
            >
                { utils.map(options, (option, key) => {
                    return (
                        <RadioButton
                            key={ `radio-button-${ key }` }
                            checkedIcon={ checkedIcon }
                            label={ option.label }
                            value={ option.value }
                            style={ { marginBottom: 10 } }
                            uncheckedIcon={ uncheckedIcon }
                        />
                    );
                }) }

                { OtherComponent ? (
                    <RadioButton
                        id='radio-button-other'
                        checkedIcon={ checkedIcon }
                        label={
                            (
                                <label htmlFor='radio-button-other' style={ { position: 'absolute', zIndex: 3 } }>
                                    <div>{ translate('fields.other') }</div>

                                    { React.createElement(OtherComponent, { input, label: '', meta }) }
                                </label>
                            )
                        }
                        style={ { paddingBottom: 40 } }
                        uncheckedIcon={ uncheckedIcon }
                        value=''
                    />
                ) : null }
            </RadioButtonGroup>
        </div>
    );
};

RenderRadioButtonGroupField.propTypes = {
    checkedIcon: PropTypes.element,
    disabled: PropTypes.bool,
    input: PropTypes.shape({
        name: PropTypes.string,
        onBlur: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        onDragStart: PropTypes.func.isRequired,
        onDrop: PropTypes.func.isRequired,
        onFocus: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
            PropTypes.bool,
        ]),
    }).isRequired,
    label: PropTypes.string.isRequired,
    meta: PropTypes.shape({
        error: PropTypes.string,
        touched: PropTypes.bool,
    }),
    options: PropTypes.oneOfType([
        PropTypes.objectOf(
            PropTypes.shape({
                label: PropTypes.string,
                value: PropTypes.oneOfType([
                    PropTypes.number,
                    PropTypes.string,
                    PropTypes.bool,
                ]),
            }),
        ),
        PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                value: PropTypes.oneOfType([
                    PropTypes.number,
                    PropTypes.string,
                    PropTypes.bool,
                ]),
            }),
        ),
    ]).isRequired,
    otherComponent: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.func,
        PropTypes.node,
    ]),
    style: PropTypes.object,
    uncheckedIcon: PropTypes.element,
    translate: PropTypes.func.isRequired,
};

export default translate(RenderRadioButtonGroupField);



// WEBPACK FOOTER //
// ./src/components/form/InputFields/RenderRadioButtonGroupField.js